/**
 * Should grad-announcement add-ons (cssName containing "grad") be offered on the
 * Announcements & Gifts page? They are senior-only products.
 *
 * Decided by the PRICELIST season first — the flow arrives with the pricelist the
 * customer is buying from (`seniors2027` → senior) — falling back to "does ANY
 * pose come from a senior (-S0) sitting" when no season is known (e.g. the pure
 * gifts flow with no pid).
 *
 * Replaces `poses[2]?.url?.includes('-S0')`: index-based detection was a lottery.
 * Students' pose lists interleave sittings sorted by pose number (school -S0
 * shoots, studio SEN01, prior-year U0xx), so whether announcements appeared
 * depended on which sitting happened to own the THIRD pose — and any student
 * with fewer than three poses lost announcements entirely (2026-07-27 report:
 * "Announcements & Gifts no longer shows any announcements").
 *
 * Poses are spraypaint records — `url` is an attribute accessor.
 */
export default function gradAddonEligible({ pricelistSeason, poses = [] }) {
  if ((pricelistSeason || '').toLowerCase().startsWith('senior')) return true;

  return poses.some((pose) => (pose?.url || '').includes('-S0'));
}
